<div class="dialog-wrapper">
  <!-- LOADER - GRAY-BLACK THEME -->
  <div class="loading-overlay" *ngIf="isDownloading">
    <div class="loader-content">
      <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
      <span>Downloading your report...</span>
    </div>
  </div>

  <div class="dialog-container" id="pdf-content">
    <!-- WATERMARK LAYER -->
    <div class="global-watermark" *ngIf="isDownloading">
      <div class="watermark-inner">
        <img src="assets/images/merakiLogo-vector.png" alt="Meraki Logo" class="wm-logo">
        <!-- <span class="wm-text">MERAKI SHIPPING</span> -->
      </div>
    </div>

    <!-- CAPTURE HEADER -->
    <div class="header">
      <div class="title-section">
        <h2 class="primary-text">Technical Performance Reference</h2>
        <p class="vessel-info secondary-text">{{ data.vesselName }} | {{ data.vesselIMO }}</p>
      </div>
      <div class="actions">
        <button mat-icon-button (click)="downloadPDF()" title="Download Protected PDF" class="pdf-btn"
          [disabled]="isDownloading">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
        <button mat-icon-button mat-dialog-close [disabled]="isDownloading">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-dialog-content class="content">
      <!-- SHOP TRIAL SECTION -->
      <section class="info-section">
        <div class="section-header">
          <mat-icon color="primary">factory</mat-icon>
          <span class="primary-text">Shop Trial Data</span>
        </div>

        <!-- Consolidated Table Capture -->
        <div class="capture-section">
          <div class="comp-header accent-text">Shop Trial Data Table</div>
          <div class="flex-column card-style">
            <div class="table-vessel">
              <table>
                <thead>
                  <tr class="no-hover">
                    <th>Load (%)</th>
                    <th>Load (kW)</th>
                    <th>RPM</th>
                    <th>ME Cons (t/d)</th>
                    <th>SFOC (g/kWh)</th>
                    <th>SFOC Corr (g/kWh)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of data.referenceData?.shopCurve" class="hover-row">
                    <td class="primary-text">{{ p.load }}%</td>
                    <td class="primary-text">{{ p.loadKw ?? p.power }}</td>
                    <td class="primary-text">{{ p.rpm }}</td>
                    <td class="primary-text">{{ p.refCons }}</td>
                    <td class="primary-text">{{ p.sfoc }}</td>
                    <td class="primary-text accent-text">{{ p.sfoc ? (p.sfoc * LCV_REF / LCV_ACTUAL | number:'1.2-2') :
                      '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Shop Trial Equations -->
        <div class="capture-section">
          <div class="comp-header accent-text">Shop Trial Equations</div>
          <div class="flex-column card-style">
            <div class="formula-grid">
              <div class="formula-item">
                <strong class="secondary-text">SFOC Corrected:</strong>
                <div class="formula-box accent-text" [innerHTML]="shopSfocCorrEq"></div>
              </div>
              <div class="formula-item">
                <strong class="secondary-text">Consumption:</strong>
                <div class="formula-box accent-text" [innerHTML]="shopConsEq"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Consolidated Chart + Table Capture -->
        <div class="capture-section">
          <div class="comp-header accent-text shop-curve-header">
            <span>Shop Trial Performance Curve</span>
            <div class="view-toggle-btns">
              <button class="toggle-view-btn" [class.active]="!showShopTable" (click)="showShopTable = false"
                title="Chart View">
                <mat-icon>show_chart</mat-icon>
              </button>
              <button class="toggle-view-btn" [class.active]="showShopTable" (click)="showShopTable = true"
                title="Table View">
                <mat-icon>table_rows</mat-icon>
              </button>
            </div>
          </div>

          <!-- CHART VIEW -->
          <div class="flex-column card-style chart-box" [hidden]="showShopTable">
            <div class="chart-vessel" *ngIf="shopChart">
              <div [chart]="shopChart" class="full-width-chart"></div>
            </div>
          </div>

          <!-- TABLE VIEW -->
          <div class="flex-column card-style" [hidden]="!showShopTable">
            <!-- Search -->
            <div class="shop-table-search">
              <mat-icon class="search-icon">search</mat-icon>
              <input type="text" placeholder="Search all columns…" [(ngModel)]="shopTableSearch"
                class="shop-search-input" />
            </div>
            <!-- Scrollable table -->
            <div class="shop-table-scroll">
              <table class="shop-curve-table">
                <thead>
                  <tr class="no-hover">
                    <th>Load (%)</th>
                    <th>Load (kW)</th>
                    <th>SFOC (g/kWh)</th>
                    <th>SFOC Corr (g/kWh)</th>
                    <th>Consumption (t/d)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of filteredShopTableData; let i = index" [class.row-even]="i % 2 === 0"
                    [class.row-odd]="i % 2 !== 0" class="hover-row">
                    <td class="primary-text">{{ r.load }}%</td>
                    <td class="primary-text">{{ r.loadKw }}</td>
                    <td class="primary-text">{{ r.sfoc }}</td>
                    <td class="primary-text accent-text">{{ r.sfocCorr }}</td>
                    <td class="primary-text">{{ r.consumption }}</td>
                  </tr>
                  <tr *ngIf="filteredShopTableData.length === 0">
                    <td colspan="5" class="secondary-text" style="text-align:center;padding:18px;">No matching rows</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Consumption Calculator -->
        <div class="capture-section">
          <div class="comp-header accent-text">Consumption Calculator</div>
          <div class="flex-column card-style">
            <div class="cons-calc-form">
              <div class="calc-field">
                <label class="secondary-text">Power</label>
                <div class="calc-input-wrap">
                  <input type="number" min="0" placeholder="Enter power…" class="calc-input"
                    (input)="onPowerInput($any($event.target).value)" />
                  <span class="calc-unit secondary-text">kW</span>
                </div>
              </div>
              <div class="calc-arrow">
                <mat-icon>arrow_forward</mat-icon>
              </div>
              <div class="calc-field">
                <label class="secondary-text">Consumption</label>
                <div class="calc-input-wrap">
                  <span class="calc-result primary-text">{{ consumptionFromPower !== null ? consumptionFromPower : '—'
                    }}</span>
                  <span class="calc-unit secondary-text">t/d</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <!-- SEA TRIAL SECTION -->
      <section class="info-section">
        <div class="section-header">
          <mat-icon color="primary">waves</mat-icon>
          <span class="primary-text">Sea Trial Data & Equations</span>
        </div>

        <!-- Consolidated Table/Formula Capture -->
        <div class="capture-section">
          <div class="comp-header accent-text">Sea Trial Reference Table & Formulas</div>
          <div class="flex-column card-style">
            <div class="formula-grid">
              <div class="formula-item">
                <strong class="secondary-text">Laden Consumption Equation:</strong>
                <div class="formula-box accent-text" [innerHTML]="formattedHeavyEq"></div>
              </div>
              <div class="formula-item">
                <strong class="secondary-text">Ballast Consumption Equation:</strong>
                <div class="formula-box accent-text" [innerHTML]="formattedLightEq"></div>
              </div>
            </div>
            <div class="table-vessel">
              <table>
                <thead>
                  <tr class="no-hover">
                    <th>Speed (kn)</th>
                    <th>Laden (t/d)</th>
                    <th>Ballast (t/d)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of data.referenceData?.seaCurve" class="hover-row">
                    <td class="primary-text">{{ p.speed }}</td>
                    <td class="primary-text">{{ p.consumptionHeavy }}</td>
                    <td class="primary-text">{{ p.consumptionLight }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="capture-section">
          <div class="comp-header accent-text">Sea Trial Performance Curves</div>
          <div class="flex-column card-style chart-box">
            <div class="chart-vessel" *ngIf="seaChart">
              <div [chart]="seaChart" class="full-width-chart"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- LADEN MATRIX SECTION -->
      <section class="info-section">
        <div class="section-header">
          <mat-icon color="primary">grid_on</mat-icon>
          <span class="primary-text">Laden Consumption Matrix</span>
        </div>

        <div class="capture-section">
          <div class="comp-header accent-text">Laden Condition Consumption Matrix</div>
          <div class="condition-block card-style">
            <div class="table-scroll">
              <table class="cons-matrix">
                <thead>
                  <tr class="no-hover">
                    <th rowspan="2">Speed (kn)</th>
                    <th [attr.colspan]="ladenDrafts.length">Draft (m)</th>
                  </tr>
                  <tr class="no-hover">
                    <th *ngFor="let d of ladenDrafts" [class.design-draft]="d == data.referenceData?.designDraft">
                      {{ d }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of speeds" class="hover-row">
                    <td class="primary-text"><strong>{{ s }}</strong></td>
                    <td *ngFor="let d of ladenDrafts" [class.design-draft]="d == data.referenceData?.designDraft"
                      class="primary-text">
                      {{ data.referenceData.consumptionTable[speeds.indexOf(s)]?.laden?.[d.toString()] || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="capture-section">
          <div class="comp-header accent-text">Laden Condition Speed/Consumption Curves</div>
          <div class="condition-block card-style chart-box">
            <div class="chart-vessel" *ngIf="ladenConsChart">
              <div [chart]="ladenConsChart" class="full-width-chart"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- BALLAST MATRIX SECTION -->
      <section class="info-section">
        <div class="section-header">
          <mat-icon color="primary">grid_off</mat-icon>
          <span class="primary-text">Ballast Consumption Matrix</span>
        </div>

        <div class="capture-section">
          <div class="comp-header accent-text">Ballast Condition Consumption Matrix</div>
          <div class="condition-block card-style">
            <div class="table-scroll">
              <table class="cons-matrix">
                <thead>
                  <tr class="no-hover">
                    <th rowspan="2">Speed (kn)</th>
                    <th [attr.colspan]="ballastDrafts.length">Draft (m)</th>
                  </tr>
                  <tr class="no-hover">
                    <th *ngFor="let d of ballastDrafts"
                      [ngClass]="{'design-draft': d == data.referenceData?.designDraft}">
                      {{ d }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of speeds" class="hover-row">
                    <td class="primary-text"><strong>{{ s }}</strong></td>
                    <td *ngFor="let d of ballastDrafts" class="primary-text"
                      [ngClass]="{'design-draft': d == data.referenceData?.designDraft}">
                      {{ data.referenceData.consumptionTable[speeds.indexOf(s)]?.ballast?.[d.toString()] || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="capture-section">
          <div class="comp-header accent-text">Ballast Condition Speed/Consumption Curves</div>
          <div class="condition-block card-style chart-box">
            <div class="chart-vessel" *ngIf="ballastConsChart">
              <div [chart]="ballastConsChart" class="full-width-chart"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- CAPTURE FOOTER -->
      <footer class="protected-footer">
        <mat-icon>security</mat-icon>
        <div class="footer-content">
          <p class="secondary-text">This document contains protected data and secure watermarks to prevent unauthorised
            use and ensure data integrity.
            Unauthorised distribution or duplication is strictly prohibited.</p>
          <!-- <img src="assets/images/merakiLogo.png" alt="Meraki Logo" class="footer-logo"> -->
        </div>
      </footer>
    </mat-dialog-content>
  </div>
</div>